import { render, staticRenderFns } from "./newQuality.vue?vue&type=template&id=9e4dcc08&scoped=true"
import script from "./newQuality.vue?vue&type=script&lang=js"
export * from "./newQuality.vue?vue&type=script&lang=js"
import style0 from "./newQuality.vue?vue&type=style&index=0&id=9e4dcc08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4dcc08",
  null
  
)

export default component.exports